module.exports = __webpack_public_path__ + "img/icon-4.d56df31b.svg";